import React, { useState } from 'react';
import { Button, Spin, Alert } from 'antd';
import OrderFormContainer from './OrderFormContainer';
import { OrderHistoryContainer } from './OrderHistoryContainer';
import {
  useDeliveryInfo,
  useOrderHistory,
  useCamasysCustomer
} from '../../../../../core-module/hooks';
import { OrderHistoryItem } from '../../../../../core-module/services/logistics/types';

const NOT_ALLOWED_KLANTSTATUS = [9, 10];

interface Props {
  customerId: number;
}

const OrderTab: React.FC<Props> = ({ customerId }) => {
  const [showOrderForm, setShowOrderForm] = useState(false);
  const [editingOrder, setEditingOrder] = useState<OrderHistoryItem | undefined>();
  const camasysCustomerQuery = useCamasysCustomer(customerId, true);
  const orderHistoryQuery = useOrderHistory(customerId, showOrderForm);

  const postalCode =
    camasysCustomerQuery && camasysCustomerQuery.camasysCustomer
      ? parseInt(camasysCustomerQuery.camasysCustomer.bezoekAdres.postcode.substr(0, 4), 10)
      : undefined;

  const customerNumber =
    camasysCustomerQuery && camasysCustomerQuery.camasysCustomer
      ? camasysCustomerQuery && camasysCustomerQuery.camasysCustomer.klantnummer
      : undefined;

  const deliveryInfoQuery = useDeliveryInfo(postalCode, customerNumber);

  const handleOpenForm = (existingOrder?: OrderHistoryItem) => {
    setShowOrderForm(true);
    setEditingOrder(existingOrder);
  };

  const handleCloseForm = () => {
    setShowOrderForm(false);
    setEditingOrder(undefined);
  };

  if (orderHistoryQuery.loading) {
    return <Spin spinning={true}>Bestelhistorie aan het ophalen...</Spin>;
  }

  if (deliveryInfoQuery.loading) {
    return <Spin spinning={true}>Leveringinformatie aan het ophalen...</Spin>;
  }

  if (camasysCustomerQuery.loading) {
    return <Spin spinning={true}>Klant uit camasys aan het ophalen...</Spin>;
  }

  if (camasysCustomerQuery.error || !camasysCustomerQuery.camasysCustomer) {
    return <p>Er is een fout opgetreden bij het ophalen van het profiel.</p>;
  }

  if (orderHistoryQuery.error) {
    return <p>Er is een fout opgetreden bij het ophalen van de bestelhistorie.</p>;
  }

  if (deliveryInfoQuery.error) {
    return <p>Er is een fout opgetreden bij het ophalen van leveringinformatie.</p>;
  }

  const customerDefaultPortionId = camasysCustomerQuery.camasysCustomer.defaultPortie
    ? camasysCustomerQuery.camasysCustomer.defaultPortie.portieID
    : null;

  return showOrderForm ? (
    <OrderFormContainer
      customerId={customerId}
      deliveryInfo={deliveryInfoQuery.deliveryInfo}
      orderHistory={orderHistoryQuery.orderHistory}
      onHideClick={handleCloseForm}
      existingOrder={editingOrder}
      customerDefaultPortionId={customerDefaultPortionId}
    />
  ) : (
    <>
      {camasysCustomerQuery.camasysCustomer.status &&
      NOT_ALLOWED_KLANTSTATUS.includes(camasysCustomerQuery.camasysCustomer.status) ? (
        <Alert
          type='warning'
          message='Voor deze klant kan geen bestelling worden ingevoerd. Neem contact op met de klantenservice.'
        />
      ) : (
        <Button
          type='primary'
          icon='plus'
          style={{ marginBottom: 15 }}
          onClick={() => handleOpenForm()}
        >
          Bestelling invoeren
        </Button>
      )}

      <OrderHistoryContainer
        orderHistory={orderHistoryQuery.orderHistory}
        deliveryInfo={deliveryInfoQuery.deliveryInfo}
        onEditClick={handleOpenForm}
      />
    </>
  );
};

export { OrderTab };
